import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';
import getApi from '@/lib/axios';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getLTVOcupacao(): Promise<ConsolidationSummaryType> {
  const api = await getApi();

  const { data } = await api.get<ConsolidationSummaryType>('/raiox/ltv_tumas/');
  return data;
}

export { getLTVOcupacao };

type QueryFnType = typeof getLTVOcupacao;

function useLTVOcupacao() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-ltv-ocupacao'],
    queryFn: () => getLTVOcupacao(),
  });
}

export { useLTVOcupacao };
